import React, {memo, forwardRef } from 'react';

const SearchFadeIn = forwardRef((props, ref) => ( 
  <div ref={ref} className={`SearchFadeInDiv FullOpacity FullWidth FullHeight FlexCenter AlignCenter TransitionEastOut ${props.speed} ${props.color}`}></div>
));

export default SearchFadeIn